module.exports = __webpack_public_path__ + "img/shalou@2x.dcce226c.png";